import { InlineText } from '@helloself/hello-self-ui';
import React, { PropsWithChildren } from 'react';

export const TagContent = ({ children }: PropsWithChildren<object>) => (
    <InlineText padding="1px 0 0 0" lineHeight="20px" fontSize="14px" fontWeight="600">
        {children}
    </InlineText>
);
